module.exports = __webpack_public_path__ + "assets/img/Arty_001.cd8c2eda-ps.jpg";